"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTransaction = void 0;
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const cryptoassets_1 = require("@ledgerhq/cryptoassets");
const createTransaction = () => ({
    family: "ethereum",
    mode: "send",
    amount: new bignumber_js_1.default(0),
    recipient: "",
    gasPrice: null,
    maxFeePerGas: null,
    maxPriorityFeePerGas: null,
    userGasLimit: null,
    estimatedGasLimit: null,
    networkInfo: null,
    feeCustomUnit: (0, cryptoassets_1.getCryptoCurrencyById)("ethereum").units[1],
    useAllAmount: false,
    feesStrategy: "medium",
});
exports.createTransaction = createTransaction;
exports.default = exports.createTransaction;
//# sourceMappingURL=createTransaction.js.map